import { API_BASE_URL, deleteRequest, getRequest, postRequest, putRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

const baseUrl = (moduleId, contentId) =>
    `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/notes`;

const toQueryString = (params = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            searchParams.set(key, value);
        }
    });
    const query = searchParams.toString();
    return query ? `?${query}` : "";
};

export const fetchContentPersonalNotesApi = (moduleId, contentId) =>
    getRequest({
        url: baseUrl(moduleId, contentId),
        token: getToken(),
        uid: getUid(),
    });

export const fetchModulePersonalNotesApi = (moduleId, filters = {}) =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/notes${toQueryString(filters)}`,
        token: getToken(),
        uid: getUid(),
    });

export const createContentPersonalNoteApi = (moduleId, contentId, payload) =>
    postRequest({
        url: baseUrl(moduleId, contentId),
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const updateContentPersonalNoteApi = (moduleId, contentId, noteId, payload) =>
    putRequest({
        url: `${baseUrl(moduleId, contentId)}/${noteId}`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const deleteContentPersonalNoteApi = (moduleId, contentId, noteId) =>
    deleteRequest({
        url: `${baseUrl(moduleId, contentId)}/${noteId}`,
        token: getToken(),
        uid: getUid(),
    });
